<button [class]="'button'" type="button">
    <i class="fa fa-times"></i>
</button>
